import React from "react";
import orgLogo from "../Global Icons/orgLogo2.png";
import { Link } from "react-router-dom";
import "./chatMirror.css"
import { ReactComponent as BackIcon } from "../Assets/Categories/BackIcon.svg";

const ChatMirror = ({ emailAddress, phone }) => {
  return (
    <div className="cm-bar">
      {/* ── Left: Back + Title ── */}
      <div className="cm-left">
        <Link to="/dashboard" className="cm-back-btn" title="Back to Dashboard">
          <BackIcon className="cm-back-icon" />
        </Link>
        <div className="cm-title-block">
          <h1 className="cm-title">Help & Support</h1>
          <p className="cm-subtitle">Manage customer conversations</p>
        </div>
      </div>

      {/* ── Right: Info Card ── */}
      <div className="cm-card">
        {/* Company */}
        <div className="cm-card-section cm-card-section--company">
          <div className="cm-card-logo-wrap">
            <img src={orgLogo} alt="Dooritt Logo" className="cm-logo" />
          </div>
          <div className="cm-card-field">
            <span className="cm-field-label">Company</span>
            <span className="cm-field-value">dooritt</span>
          </div>
        </div>

        <div className="cm-card-divider" />

        {/* Contact info */}
        <div className="cm-card-section cm-card-section--contact">
          <div className="cm-contact-item">
            <svg className="cm-contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="m22 7-10 7L2 7" />
            </svg>
            <div className="cm-card-field">
              <span className="cm-field-label">Email</span>
              <span className="cm-field-value">{emailAddress || "No data"}</span>
            </div>
          </div>

          <div className="cm-contact-item">
            <svg className="cm-contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6 6l1.27-.95a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <div className="cm-card-field">
              <span className="cm-field-label">Phone</span>
              <span className="cm-field-value">{phone || "No data"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMirror;